import React from 'react'
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton';
import '../../styles/partials/components/_table.scss';
import Folder from "./Folder";
import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Video from "./Video";
import EmptyNotes from "../empty-states/EmptyNotes";

const Table = ({folder, previousFolder, folders, videos, selectVideo, isLoading, loadMore, handleScrollEnd}) => {
  // Use the state and functions returned from useTable to build your UI

  return (
    <div className="table">
      <div className="row title-row">
        <div className="column-title">Name</div>
        <div className="column-title">Notes</div>
        <div className="column-title">Modified</div>
        <div className="column-title">Members</div>
        <div className="column-title"/>
      </div>
      <div className="table-content" onScroll={handleScrollEnd}>
        <SkeletonTheme color="#f4f4f4" highlightColor="#fafafa">
          {isLoading && <Skeleton count={10}/>}
          {!isLoading && previousFolder && <Folder folder={previousFolder} goBack={true}/>}
          {
            !isLoading && folders.map(folder => <Folder folder={folder} key={folder.id}/>)
          }

          {!isLoading && Object.keys(videos).map(key => {
            return (
              <Video
                selectVideo={selectVideo}
                videos={videos}
                videoId={key}
                key={key}
              />
            )
          })}
        </SkeletonTheme>
        {!isLoading && folders.length < 1 && Object.keys(videos).length < 1 && !folder && <EmptyNotes/>}
        <div className="loader-container">
          <Loader
            type="ThreeDots"
            color="#8c9fa8"
            height={50}
            width={50}
            visible={loadMore}
          />
        </div>
      </div>
    </div>
  )
};

export default Table;
